import SETTINGS from '@/src/settings'

const fraisPreparationPharmedistore = SETTINGS.FRAIS_PREPARATION_DECLINATION_ID
const fraisPreparationAllPharmedicap = SETTINGS.FRAIS_PREPARATION_CAP_DECLINATION_ID

const fraisPreparationPharmedicap = SETTINGS.FRAIS_PREPARATION_PHARMEDICAP_DECLINATION_ID
const fraisPreparationNorcap = SETTINGS.FRAIS_PREPARATION_NORCAP_DECLINATION_ID

export const removeDisplayFraisDePrepraProduct = items =>
  items.product_id !== SETTINGS.FRAIS_PREPARATION_DECLINATION_ID &&
  items.product_id !== SETTINGS.FRAIS_PREPARATION_CAP_DECLINATION_ID &&
  items.product_id !== SETTINGS.FRAIS_PREPARATION_PHARMEDICAP_DECLINATION_ID &&
  items.product_id !== SETTINGS.FRAIS_PREPARATION_NORCAP_DECLINATION_ID

export const removeDisplayFraisDePrepraProductGroupIfUniqueProduct = group => {
  return (
    group.products.filter(
      item =>
        item.product_id !== SETTINGS.FRAIS_PREPARATION_DECLINATION_ID &&
        item.product_id !== SETTINGS.FRAIS_PREPARATION_CAP_DECLINATION_ID &&
        item.product_id !== SETTINGS.FRAIS_PREPARATION_PHARMEDICAP_DECLINATION_ID &&
        item.product_id !== SETTINGS.FRAIS_PREPARATION_NORCAP_DECLINATION_ID
    ).length > 0
  )
}

export const rulesUpdateProductFraisPrepa = products => {
  const isAddFraisPreparation = products.find(
    p =>
      p.product_id === fraisPreparationPharmedistore ||
      p.product_id === fraisPreparationAllPharmedicap ||
      p.product_id === fraisPreparationPharmedicap ||
      p.product_id === fraisPreparationNorcap
  )

  return !!isAddFraisPreparation
}
